import { fetchWrapper } from '@/_helpers';
const BASE_URL = 'teams/settings';
export const teamSettingsApi = {
    getTeamSettings: (teamId, settingName) => {
        return fetchWrapper.get(`${BASE_URL}/${teamId}`);
    },
    // Visit Labels
    updateVisitLabels: (teamId, data) => {
        return fetchWrapper.post(`${BASE_URL}/${teamId}/visit-labels`, data);
    },
    deleteVisitLabels: (teamId) => {
        return fetchWrapper.delete(`${BASE_URL}/${teamId}/visit-labels`);
    },
};
